import { useEffect, useRef, useState } from "react";
import { getMailTrace } from "../../services/MailLogs";
import { useAuth } from "../../context/AuthContext";

function TraceWindow({ id, queueId, zIndex, onClose, bringToFront }) {
  const { accessToken } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [pos, setPos] = useState({
    top: 80 + id * 20,
    left: 120 + id * 20,
  });
  const dragRef = useRef({ x: 0, y: 0, top: 0, left: 0 });
  const draggingRef = useRef(false);
  const rafRef = useRef(null);

  useEffect(() => {
    getMailTrace(queueId, accessToken)
      .then((x) => setItems(x || []))
      .finally(() => setLoading(false));
  }, [queueId, accessToken]);

  const onMouseDown = (e) => {
    bringToFront(id);
    e.preventDefault();
    draggingRef.current = true;
    dragRef.current = {
      x: e.clientX,
      y: e.clientY,
      top: pos.top,
      left: pos.left,
    };
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp, { once: true });
  };
  const onMouseMove = (e) => {
    if (!draggingRef.current) return;
    const dx = e.clientX - dragRef.current.x;
    const dy = e.clientY - dragRef.current.y;
    const next = {
      top: Math.max(0, dragRef.current.top + dy),
      left: Math.max(0, dragRef.current.left + dx),
    };
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => setPos(next));
  };

  const onMouseUp = () => {
    draggingRef.current = false;
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };

  useEffect(() => {
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  return (
    <div
      className="shadow border rounded"
      style={{
        position: "fixed",
        top: pos.top,
        left: pos.left,
        width: 640,
        height: 520,
        background: "#fff",
        zIndex,
        resize: "both",
        overflow: "auto",
      }}
      onMouseDown={() => bringToFront(id)}
    >
      <div
        className="d-flex align-items-center justify-content-between bg-light border-bottom px-2 py-1 user-select-none"
        style={{ cursor: "move" }}
        onMouseDown={onMouseDown}
      >
        <strong className="me-2">Ślad: {queueId}</strong>
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-outline-secondary p-1 lh-1"
            title="Kopiuj ID wysyłki"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(queueId);
            }}
          >
            <i className="bi bi-clipboard"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-secondary p-1 lh-1"
            title="Zamknij"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onClose(id);
            }}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      </div>

      <div className="p-2">
        {loading ? (
          <div className="d-flex align-items-center gap-2">
            <span className="spinner-border spinner-border-sm" /> Ładowanie…
          </div>
        ) : !items.length ? (
          <div className="text-muted">Brak wpisów śladu.</div>
        ) : (
          <ul className="list-group">
            {items.map((ev, idx) => (
              <li key={idx} className="list-group-item">
                <div className="small text-muted">
                  {ev.ts ? new Date(ev.ts).toLocaleString("pl-PL") : "—"}
                </div>
                <code className="d-block text-wrap">{ev.raw}</code>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default TraceWindow;
